const cname = 'active'

export default class TabGallery {
	constructor(element) {
		this.root = element
		this.slides = this.root.querySelectorAll('.slide')
		this.cursors = this.root.querySelectorAll('.cursor')

		if (!this.root || this.slides.length === 0 || this.cursors === 0) return

		this.currentSlide = this.slides[0]
		this.currentCurosr = this.cursors[0]
		this.currentSlide.classList.add(cname)
		this.currentCurosr.classList.add(cname)

		this.cursors.forEach(item => item.onclick = this.onCursorClick.bind(this))
	}

	onCursorClick(e) {
		let cursor = e.currentTarget
		let slide = this.slides[parseInt(cursor.dataset.index)]
		
		this.currentSlide.classList.remove(cname)
		this.currentCurosr.classList.remove(cname)
		this.currentSlide = slide
		this.currentCurosr = cursor
		this.currentSlide.classList.add(cname)
		this.currentCurosr.classList.add(cname)
	}
}
